
import {
    Slider, SliderTrack, SliderFilledTrack, SliderThumb, SliderMark,
    Drawer, DrawerHeader,DrawerBody,DrawerFooter,DrawerContent ,DrawerOverlay
  } from '@chakra-ui/react'

export const OptionDraw = ({setIsOptionsOpen,isOptionsOpen,probability,setProbability})=>{
    return <Drawer placement={"bottom"} onClose={()=>{setIsOptionsOpen(false)}} isOpen={isOptionsOpen}>
    {/* <DrawerOverlay /> */}
    <DrawerContent>
      <DrawerHeader borderBottomWidth='1px'>{probability}%</DrawerHeader>
      <DrawerBody paddingTop={7}>
        <Slider defaultValue={probability} min={0} max={100} step={1} onChange={setProbability}>
          <SliderTrack bg='red.100'>
            <SliderFilledTrack bg='tomato' />
          </SliderTrack>
          <SliderThumb boxSize={6} />
        </Slider>
      </DrawerBody>
      <DrawerFooter>
      </DrawerFooter>
    </DrawerContent>
    </Drawer>
}

export const StyleDraw = ({setIsStyleOpen,isStyleOpen,radius,setRadius})=>{
    return <Drawer placement={"bottom"} onClose={()=>{setIsStyleOpen(false)}} isOpen={isStyleOpen}>
    {/* <DrawerOverlay /> */}
    <DrawerContent>
      <DrawerHeader borderBottomWidth='1px'>{radius}</DrawerHeader>
      <DrawerBody paddingTop={7}>
        <Slider defaultValue={radius} min={0} max={100} step={1} onChange={setRadius}>
          <SliderTrack bg='red.100'>
            <SliderFilledTrack bg='tomato' />
          </SliderTrack>
          <SliderThumb boxSize={6} />
        </Slider>
      </DrawerBody>
      <DrawerFooter>
      </DrawerFooter>
    </DrawerContent>
  </Drawer>
}